module.exports = __webpack_public_path__ + "static/media/404.30b7b3db.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/404.png
// module id = 207
// module chunks = 0